import pl from "@locales/validation/pl.json";
import en from "@locales/validation/en.json";

export default {
  pl: pl,
  en: en,
};
